<template>
  <div class="team-holder primary-color-text text-base-2">
    <div class="justify-content-center">
      <span class="img-holder">
        <nuxt-picture
          preload
          :img-attrs="{class: 'responsive-img', alt: teamItem.name + ' | ' + teamItem.position}"
          :src="teamItem.image"
          :placeholder="[100, 50, 10]"
          sizes=""
        />
      </span>
      <span class="team-text">
        <span class="name">{{ teamItem.name }}</span>
        <span class="position">{{ teamItem.position }}</span>
      </span>
    </div>
  </div>
</template>

<script setup>
const team = [
  {
    name: 'Anastasiya C.',
    position: 'Sr. Account Executive',
    image: '/img/other/sales/anastasiyac.jpg'
  },
  {
    name: 'Oliver H.',
    position: 'Sr. Account Executive',
    image: '/img/other/sales/oliverh.jpg'
  },
  {
    name: 'Elena D.',
    position: 'Sales Team Lead',
    image: '/img/other/sales/elenad.jpg'
  },
  {
    name: 'Brad S.',
    position: 'Sr. Account Executive',
    image: '/img/other/sales/brads.jpg'
  }
]

/**
* Active Team tem
*/
const teamItem = computed({
  get () {
    const randomIndex = Math.floor(Math.random() * team.length)
    const randomElement = team[randomIndex]

    return randomElement
  }
})
</script>

<style lang="scss">
.team-holder {
  width: 100%;
  padding: 1rem;
  margin-top: 1rem;
  border: 1px solid rgba(1,82,135,.3);
  border-radius: 5px;
  @media only screen and (min-width: 601px) {
    padding: 1.25rem 0 0;
    border-width: 0;
  }
  @media only screen and (min-width: 993px) {
    padding: 1.25rem 0 0;
    border-top: 1px solid rgba(1,82,135,.3);
    border-radius: 0;
  }
  & > div,
  span {
    display: flex;
    align-items: center;
  }
  .img-holder {
    flex-shrink: 0;
    overflow: hidden;
    width: 50px;
    height: 50px;
    margin-right: 1rem;
    border-radius: 50%;
    @media only screen and (min-width: 601px) {
      width: 4rem;
      height: 4rem;
    }
  }
  .team-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: .625rem;
    .name {
      font-weight: 500;
    }
    .position {
      font-size: 11px;
      letter-spacing: 1px;
      text-transform: uppercase;
      white-space: nowrap;
      opacity: .8;
    }
  }
}
</style>
